/**
 * Carddo Mistón — GA4 storefront tracking (pre-checkout)
 * Checkout funnel (Bold/Sumas, formulario, envío) → Custom Pixel en Shopify Admin
 */
(function () {
  'use strict';

  var config = window.carddoGA4;
  if (!config || !config.measurementId) return;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', config.measurementId, {
    send_page_view: true,
    currency: config.currency,
    debug_mode: !!config.debug
  });

  function centsToMajor(value) {
    var n = Number(value);
    if (!n || isNaN(n)) return 0;
    return n / 100;
  }

  function getBrowserContext() {
    var ua = navigator.userAgent || '';
    return {
      in_app_browser: /Instagram|FBAN|FBAV|FB_IAB/i.test(ua) ? 'yes' : 'no',
      in_app_type: /Instagram/i.test(ua) ? 'instagram' : /FBAN|FBAV|FB_IAB/i.test(ua) ? 'facebook' : 'none',
      device_type: window.innerWidth < 768 ? 'mobile' : 'desktop'
    };
  }

  function mapCartLine(item) {
    return {
      item_id: String(item.sku || item.variant_id || item.id),
      item_name: item.product_title || item.title,
      item_variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : undefined,
      price: centsToMajor(item.final_price || item.price),
      quantity: item.quantity || 1
    };
  }

  function mapCart(cart) {
    if (!cart || !cart.items) return { items: [], value: 0, item_count: 0 };
    return {
      items: cart.items.map(mapCartLine),
      value: centsToMajor(cart.total_price),
      item_count: cart.item_count || cart.items.length,
      currency: cart.currency || config.currency
    };
  }

  function sendEvent(eventName, params) {
    var payload = Object.assign({}, getBrowserContext(), params || {});
    if (config.debug) payload.debug_mode = true;
    gtag('event', eventName, payload);
  }

  function getShipModalData() {
    var modal = document.getElementById('cdr-ship-modal');
    if (!modal) return null;
    return {
      city1_name: modal.getAttribute('data-city1-name'),
      city1_cost: Number(modal.getAttribute('data-city1-cost') || 0),
      city2_name: modal.getAttribute('data-city2-name'),
      city2_cost: Number(modal.getAttribute('data-city2-cost') || 0),
      free_threshold: Number(modal.getAttribute('data-free-threshold') || 0)
    };
  }

  function getSelectedShipCity() {
    try {
      return localStorage.getItem('cdr_ship_city') || 'bogota';
    } catch (e) {
      return 'bogota';
    }
  }

  function estimateShipping(cart) {
    var ship = getShipModalData();
    if (!ship || !cart) return null;

    var city = getSelectedShipCity();
    var isBogota = city === 'bogota';
    var costCents = isBogota ? ship.city1_cost : ship.city2_cost;
    var cityLabel = isBogota ? ship.city1_name : ship.city2_name;
    var subtotal = Number(cart.total_price || 0);
    var isFree = subtotal >= ship.free_threshold;

    return {
      ship_city_key: city,
      ship_city_label: cityLabel,
      shipping_cost: centsToMajor(isFree ? 0 : costCents),
      shipping_cost_cents: isFree ? 0 : costCents,
      free_shipping: isFree ? 'yes' : 'no',
      free_shipping_threshold: centsToMajor(ship.free_threshold),
      amount_to_free_shipping: isFree ? 0 : centsToMajor(Math.max(0, ship.free_threshold - subtotal))
    };
  }

  function fetchCart(callback) {
    if (window.Shopify && typeof window.Shopify.getCart === 'function') {
      window.Shopify.getCart(callback);
      return;
    }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(callback)
      .catch(function () { callback(null); });
  }

  function trackViewCart(source) {
    fetchCart(function (cart) {
      if (!cart || !cart.item_count) return;
      var mapped = mapCart(cart);
      var shipping = estimateShipping(cart);
      sendEvent('view_cart', {
        currency: mapped.currency,
        value: mapped.value,
        items: mapped.items,
        cart_source: source,
        item_count: mapped.item_count,
        shipping_estimate: shipping ? shipping.shipping_cost : undefined,
        ship_city: shipping ? shipping.ship_city_label : undefined
      });
    });
  }

  function trackAddToCart(lineItem) {
    if (!lineItem) return;
    var item = {
      item_id: String(lineItem.sku || lineItem.variant_id || lineItem.id),
      item_name: lineItem.product_title || lineItem.title,
      item_variant: lineItem.variant_title && lineItem.variant_title !== 'Default Title' ? lineItem.variant_title : undefined,
      price: centsToMajor(lineItem.final_price || lineItem.price),
      quantity: lineItem.quantity || 1
    };
    sendEvent('add_to_cart', {
      currency: config.currency,
      value: item.price * item.quantity,
      items: [item]
    });
  }

  function trackBeginCheckout(source) {
    fetchCart(function (cart) {
      if (!cart || !cart.item_count) return;
      var mapped = mapCart(cart);
      var shipping = estimateShipping(cart);
      var coupon = '';
      try { coupon = localStorage.getItem('couponCode') || ''; } catch (e) {}

      sendEvent('begin_checkout', {
        currency: mapped.currency,
        value: mapped.value,
        items: mapped.items,
        checkout_source: source,
        coupon: coupon || undefined,
        item_count: mapped.item_count
      });

      sendEvent('carddo_begin_checkout_click', {
        currency: mapped.currency,
        value: mapped.value,
        checkout_source: source,
        item_count: mapped.item_count,
        coupon: coupon || undefined,
        ship_city: shipping ? shipping.ship_city_label : undefined,
        shipping_estimate: shipping ? shipping.shipping_cost : undefined,
        free_shipping: shipping ? shipping.free_shipping : undefined,
        amount_to_free_shipping: shipping ? shipping.amount_to_free_shipping : undefined,
        cart_total_with_shipping: shipping
          ? mapped.value + shipping.shipping_cost
          : mapped.value
      });
    });
  }

  function initWhenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  initWhenReady(function () {
    // Mini-cart / drawer open
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.js-toggle-cart');
      if (toggle) {
        setTimeout(function () { trackViewCart('mini_cart'); }, 400);
      }
    });

    // Checkout buttons (drawer + cart page)
    document.addEventListener('click', function (e) {
      var checkoutBtn = e.target.closest('.js-cart-btn-checkout, .btn-cart-checkout, button[name="checkout"]');
      if (!checkoutBtn || checkoutBtn.classList.contains('disabled')) return;
      var source = checkoutBtn.classList.contains('btn-cart-checkout') || checkoutBtn.name === 'checkout'
        ? 'cart_page'
        : 'mini_cart';
      trackBeginCheckout(source);
    });

    // Shipping estimate modal
    document.addEventListener('click', function (e) {
      if (e.target.closest('#js-ship-action-btn')) {
        sendEvent('carddo_shipping_modal_open', { step: 'shipping_estimate' });
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.js-confirm-ship')) return;
      fetchCart(function (cart) {
        var shipping = estimateShipping(cart);
        var mapped = cart ? mapCart(cart) : { value: 0, currency: config.currency };
        sendEvent('carddo_shipping_estimate_confirmed', Object.assign({}, shipping || {}, {
          currency: mapped.currency,
          cart_value: mapped.value,
          cart_total_with_shipping: shipping ? mapped.value + shipping.shipping_cost : mapped.value
        }));
      });
    });

    // Coupon applied via /discount/ redirect
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.js-apply-coupon')) return;
      var input = document.getElementById('cdr-coupon-input');
      var code = input ? (input.value || '').trim().toUpperCase() : '';
      if (!code) {
        sendEvent('carddo_coupon_error', { error_type: 'empty_code' });
        return;
      }
      sendEvent('carddo_coupon_attempt', { coupon: code });
      setTimeout(function () {
        try {
          var stored = localStorage.getItem('couponCode');
          if (stored && stored.toUpperCase() === code) {
            sendEvent('carddo_coupon_applied', { coupon: code });
          }
        } catch (err) { /* ignore */ }
      }, 800);
    });

    // Cart page view
    if (document.body.classList.contains('template-cart')) {
      trackViewCart('cart_page');
    }

    // Product page view_item
    if (document.body.classList.contains('template-product')) {
      var productJson = document.querySelector('script[id^="ProductJson-"]');
      if (productJson) {
        try {
          var product = JSON.parse(productJson.textContent);
          var variantId = new URLSearchParams(window.location.search).get('variant');
          var variant = (product.variants || []).find(function (v) {
            return String(v.id) === String(variantId);
          }) || (product.variants || []).find(function (v) { return v.available; }) || product.variants[0];
          if (variant) {
            sendEvent('view_item', {
              currency: config.currency,
              value: centsToMajor(variant.price),
              items: [{
                item_id: String(variant.sku || variant.id),
                item_name: product.title,
                item_variant: variant.title !== 'Default Title' ? variant.title : undefined,
                price: centsToMajor(variant.price)
              }]
            });
          }
        } catch (err) { /* ignore */ }
      }
    }

    // Intercept add to cart (Ajax)
    if (window.jQuery) {
      window.jQuery(document).ajaxSuccess(function (_event, xhr, settings) {
        if (!settings || !settings.url || settings.url.indexOf('/cart/add') === -1) return;
        try {
          trackAddToCart(JSON.parse(xhr.responseText));
        } catch (err) { /* ignore */ }
      });
    }
  });
})();
